export default "__VITE_ASSET__NSwk6vh0__"